import { Container, IconButton, Typography } from '@material-ui/core'
import { ArrowBack } from '@material-ui/icons'
import { useRef, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { toast } from 'react-toastify'

import Button from '@/components/button'
import { useGetCogUrlFromDiagnosis } from '@/hooks/queries/use-get-cog-url-from-diagnosis'
import { useGetPerimeterData } from '@/hooks/queries/use-get-perimeter-data'
import { getDemandAnalysisDecisionAnswer } from '@/services/demand-analysis-decision-answer'

import { DecisionModal } from '../../components/decision-modal'
import { Map, MapHandle } from '../../components/map'
import { useDemandAnalysisStore } from '../../contexts/demand-analysis-store-context'
import { useDemandAnalysisRoute } from '../../hooks/use-demand-analysis-route'
import { useStyles } from './styles'

export function EditPerimeter() {
  const classes = useStyles()
  const navigate = useNavigate()

  const [decisionModalOpen, setDecisionModalOpen] = useState(false)
  const mapRef = useRef<MapHandle>(null)

  const { diagnosisId, makeUrl, culture } = useDemandAnalysisRoute()
  const { data: perimeterData } = useGetPerimeterData(diagnosisId!)
  const { data: cogUrl } = useGetCogUrlFromDiagnosis(culture!, diagnosisId!)

  const { perimeterFromInput, setPerimeter } = useDemandAnalysisStore(
    (state) => ({
      perimeterFromInput: state.perimeter?.results.geojson,
      setPerimeter: state.setPerimeter,
    }),
  )

  const perimeter = perimeterFromInput || perimeterData

  function handleSave() {
    const answer = getDemandAnalysisDecisionAnswer('edition')

    if (!answer) return setDecisionModalOpen(true)

    onSubmit()
  }

  async function onSubmit() {
    if (!mapRef.current) return

    try {
      const { zip, files, geojson, results } =
        await mapRef.current.getShapefileFiles()

      setPerimeter({
        edited: true,
        zip,
        shapefile: files,
        results: {
          filename: results.filename,
          area: results.interestArea,
          centroid: results.centroid,
          geojson,
        },
      })
      navigate(makeUrl('resume'))
    } catch (error: any) {
      toast.error(`Erro ao salvar o perímetro: ${error?.message}`)
    }
  }

  return (
    <Container className={classes.container}>
      <header className={classes.header}>
        <IconButton
          size='small'
          onClick={() => navigate(-1)}
          color='secondary'
          aria-label='Voltar'
        >
          <ArrowBack />
        </IconButton>

        <div>
          <Typography variant='h2'>Editar perímetro</Typography>
        </div>
      </header>

      <div className={classes.content}>
        {perimeterData && cogUrl && (
          <Map ref={mapRef} perimeter={perimeter} cogUrl={cogUrl} editable />
        )}
      </div>

      <footer className={classes.footer}>
        <Button outlined onClick={() => navigate(-1)}>
          Cancelar
        </Button>
        <Button onClick={handleSave}>Salvar Edição</Button>
      </footer>

      <DecisionModal
        variant='edition'
        open={decisionModalOpen}
        onClose={() => setDecisionModalOpen(false)}
        onSubmit={onSubmit}
      />
    </Container>
  )
}
